import { makeStyles } from "@material-ui/core/styles";
export const useEventoStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "0",
    margin: "10px 0"
  },
  details: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "cemter",
    alignItems: "center",
    gap: "10px",
    padding: "0",
    margin: "0",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "cemter",
    alignItems: "flex-start",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  controls: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    gap: "10px",
    justifyContent: "cemter",
    alignItems: "flex-start",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  alingText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "cemter",
    alignItems: "center",
    padding: "0",
    margin: "5px 0",
  },
  icon: {
    padding: "0",
    margin: "0 5px",
  }
}));
export const useVEventoStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "0 15px",
    margin: "0",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "cemter",
    alignItems: "center",
    padding: "0",
    margin: "5px 0",
  },
  containerHead: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0",
    margin: "5px 2rem",
  }
}));